// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__385Fz","errorLogs":"EditorFooter_errorLogs__oyelR"};